package fr.frux.core.common.di

import fr.frux.core.common.auth.TokenStorage
import fr.frux.core.common.auth.createTokenStorage
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn

/**
 * Metro DI module providing TokenStorage.
 */
@ContributesTo(AppScope::class)
interface TokenStorageModule {

    companion object {
        /**
         * Provides singleton TokenStorage instance.
         * Uses platform-specific implementation via expect/actual.
         */
        @Provides
        @SingleIn(AppScope::class)
        fun provideTokenStorage(): TokenStorage {
            return createTokenStorage()
        }
    }
}